import React from "react";
import { BsFillEmojiNeutralFill } from "react-icons/bs";
import { RiEmotionHappyFill, RiEmotionUnhappyFill } from "react-icons/ri";

import {
  conversationStatusEnums,
  CONVERSATION_STATUS_ICON_SIZE,
} from "../../../constants";

const STATUS_ICON_CONFIG = {
  [conversationStatusEnums.POSITIVE]: {
    Icon: RiEmotionHappyFill,
    className: "p-1 rounded bg-success d-flex align-items-center text-white",
  },
  [conversationStatusEnums.PASSIVE]: {
    Icon: BsFillEmojiNeutralFill,
    className: "p-1 rounded bg-warning d-flex align-items-center text-white",
  },
  [conversationStatusEnums.NEGATIVE]: {
    Icon: RiEmotionUnhappyFill,
    className: "p-1 rounded bg-danger d-flex align-items-center text-white",
  },
};

/**
 * Renders the NPS / conversation status emoji icon from a status enum value.
 */
const ConversationStatusIcon = ({
  status,
  size = CONVERSATION_STATUS_ICON_SIZE,
}) => {
  const config =
    STATUS_ICON_CONFIG[status] ||
    STATUS_ICON_CONFIG[conversationStatusEnums.NEGATIVE];
  const { Icon, className } = config;

  return (
    <span className={className}>
      <Icon size={size} />
    </span>
  );
};

export default ConversationStatusIcon;
